import React, { useEffect, useState } from 'react';
import "./JobSettings.scss";
import HourlyJobTable from './JobSettingsTabs/HourlyJobTable';
import apiClient from "../../../../../../Config/apiClient";
import Loader from "../../../../../../Context/Loader/Loader";
import { showSuccessToast, showErrorToast } from "../../../../../../Context/Toaster/Toaster";

const jobSettingsPath = process.env.REACT_APP_HS_JOB_SETTINGS_BASE_PATH;

const JobSettings = () => {
  const [settings, setSettings] = useState(null);
  const [activeTab, setActiveTab] = useState("tab1");
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        setLoading(true);
        const res = await apiClient.get(`${jobSettingsPath}/get`);
        if (res.data.status === "SUCCESS") {
          setSettings(res.data.data);
        }
      } catch (error) {
        showErrorToast("Failed to fetch job settings");
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  const handleSave = async () => {
    try {
      setSaving(true);
      const res = await apiClient.put(`${jobSettingsPath}/update`, {
        auto_lock_job: settings?.auto_lock_job || 0,
        lock_time: settings?.lock_time || "",
        hourly_job_comp: settings?.hourly_job_comp || 0,
        comp_hours: settings?.comp_hours || "",
      });

      if (res.data.status === "SUCCESS") {
        setSettings(res.data.data);
        showSuccessToast("Job settings updated successfully!");
      }
    } catch (error) {
      showErrorToast("Failed to update job settings");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="text-center"><Loader /></div>;

  return (
    <div className="report-wraper">
      <div className="tab-content" id="myTabContent">
        <div className="tab-pane fade show active" id="start" role="tabpanel" aria-labelledby="start-tab">
          <div className='report-tabinner'>
            <div className="reportform-cover mt-0">

              <div className="vrt-split mb-3">
                <h3>Job Expiry</h3>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="cp-split">
                    <div className="hscommon-check">
                      <input className="common-check" type="checkbox" id="autoLockJob" checked={!!settings?.auto_lock_job} onChange={(e) => setSettings((prev) => ({ ...prev, auto_lock_job: e.target.checked ? 1 : 0, }))} />
                      <label className="form-check-label" htmlFor="autoLockJob">
                        Auto Lock Jobs <span style={{ color: "red" }}>*</span>
                      </label>
                    </div>
                    <select className="common-select" value={settings?.lock_time || ""} onChange={(e) => setSettings((prev) => ({ ...prev, lock_time: e.target.value, }))} >
                      <option value="4 hours">Before 4 Hours of Start Time</option>
                      <option value="24 hours">Before 24 Hours of Start Time</option>
                      <option value="48 hours">Before 48 Hours of Start Time</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="vrt-split vrt-padding mt-2 mb-3">
                  <h3>
                    Cancellation Charges <span className='italic-text'>(If Job Already Started)</span>
                  </h3>
                </div>
                <div className="col-md-12 inner-tab-container">
                  <div className="aptab-header mb-3">
                    <ul className="nav nav-tabs innertab-list" id="myTab" role="tablist">
                      {[
                        { id: "tab1", label: "Hourly Job" },
                      ].map(({ id, label }) => (
                        <li className="nav-item" role="presentation" key={id}>
                          <button className={`nav-link tab-btn ${activeTab === id ? "active" : ""}`} onClick={() => setActiveTab(id)}>
                            {label}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="aptab-body">
                    {activeTab === "tab1" && (
                      <HourlyJobTable checked={!!settings?.hourly_job_comp}
                        onCheckChange={(e) => setSettings((prev) => ({ ...prev, hourly_job_comp: e.target.checked ? 1 : 0, }))}
                        options={["4 Hours", "8 Hours"]}
                        onOptionChange={(e) => setSettings((prev) => ({ ...prev, comp_hours: e.target.value, }))}
                      />
                    )}
                  </div>
                </div>
              </div>

              <button className="cp-button generate-button" onClick={handleSave} disabled={saving}>
                {saving ? <Loader /> : "Save"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobSettings;